<template>
	<div class="knowledgebasedetails">
		<div class="topbagdiv">
			<div class="logodiv">
				<img src="../../assets/images/logo.png" />
			</div>
			<div class="titlediv">
				<div class="usertitle">药王知识库</div>
			</div>
			<div class="backdiv">
				<back></back>
			</div>
		</div>
		<div class="bcc">
			<div class="aaaaaaa">
				<div class="bcctitle">
					<div class="bcctitle-left" v-if="txtlist != null">
						{{ txtlist.cmsKnowledgePointsTypeList[0].name }}
					</div>
					<div class="bcctitle-right">
						<a href="javascript:void(0);" @click="$router.push('/personal/usermodule/learningrecords')">学习历史</a>
						<a href="javascript:void(0);" @click="$router.push('/personal/usermodule/messagereply')">留言中心</a>
					</div>
				</div>
				<div class="bcccontent">
					<div class="bcccontents">
						<div class="ctt">
							<div class="ctttitle" v-if="txtlist != null">
								<p>{{txtlist.cmsKnowledgePointsTypeList[0].name}}</p>
								<img v-if="txtlist.cmsKnowledgePointsTypeList[0].name==='人物生平'" src="../../assets/images/rwsp.png" />
								<img v-if="txtlist.cmsKnowledgePointsTypeList[0].name==='主要成就'" src="../../assets/images/zycj.png" />
								<img v-if="txtlist.cmsKnowledgePointsTypeList[0].name==='人物评价'" src="../../assets/images/rwpj.png" />
								<img v-if="txtlist.cmsKnowledgePointsTypeList[0].name==='年龄争议'" src="../../assets/images/nlzy.png" />
							</div>
							<div class="cttitle">
								<p class="time" v-if="txtlist != null">
									上传时间：{{ gettime(txtlist.createdAt) }}
								</p>
								<div class="cctitle" v-if="txtlist != null">
									{{ txtlist.title }}
								</div>
								<div class="content" v-if="txtlist != null" v-html="txtlist.content"></div>
								<!-- <div class="footercontent">
									<div class="left"><a href="javascript:void(0);">上一篇</a></div>
									<div class="right">
										<a href="javascript:void(0);">下一篇</a>
									</div>
								</div> -->
							</div>
						</div>
						<div class="message">
							<div class="mtitle">
								<img src="../../assets/images/send1.png" />留言框
							</div>
							<div class="textareabox">
								<textarea class="tttt" @change="changetxt" v-model.lazy="usermessage"></textarea>
							</div>
							<div class="submitbtnbox">
								<span ref="mess">请输入内容</span>
								<div style="height: 3rem;">
									<a href="javascript:void(0);" @click="submitmessage">
										<div class="aaaaaaaaaaaaaaaaaa">发表留言</div>
									</a>
								</div>
							</div>
						</div>
						<div class="messageitembox" v-if="messagelist != null">
							<div class="messageitem" v-for="item in messagelist" :key="item.id">
								<div class="top">
									<div>{{item.messageUserName}}:</div>
									<div>{{setData(item.messageTime)}}</div>
								</div>
								<div class="itemccc">
									{{item.messageContent}}
								</div>
								<div class="hfhf" v-if="item.list.length>0">
									<div v-for="ii in item.list">
										<div class="top">
											<div>{{ii.name}}:</div>
											<div>{{setData(ii.message_time)}}</div>
										</div>
										<div class="itemccc">
											{{ii.message_content}}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="pagediv center mt" v-if="pages>1">
							<a href="javascript:void(0);" class="pagebtn mr" @click="sy"><span>首页</span></a>
							<a href="javascript:void(0);" class="pagebtn mr" @click="syy"><span>上一页</span></a>
							<a href="javascript:void(0);" class="pagenum mr" v-if="pageslist!=null" v-for="i in pageslist" :data-id="i" @click="selectpage(i)"><span>{{i}}</span></a>
							<!-- <a href="javascript:void(0);" class="pagenum mr pageactive"><span>2</span></a> -->
							<a href="javascript:void(0);" class="pagebtn mr" @click="xyy"><span>下一页</span></a>
							<a href="javascript:void(0);" class="pagebtn" @click="wy"><span>尾页</span></a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<popup ref="popup" :types="'success'" :message="'留言回复成功,请等待管理员审核。'"></popup>
	</div>
</template>

<script>
	import back from "../backhome/back.vue";
	import popup from '../popups/popup.vue'
	import axios from "axios";
	export default {
		components: {
			back,popup
		},
		data() {
			return {
				token: this.$store.state.token, //token
				userid: this.$store.state.userid, //id
				type: "",
				startTime: null,
				endTime: null,
				txtlist: null,
				usermessage: null,
				messagelist: [],
				pageNum: 1,
				pageSize: 20,
				pages: 0,//总页数
				pageslist: null,//只显示五页
			};
		},
		created() {
			this.gettxt()
			this.getmessagelist()
		},
		mounted() {

		},
		beforeDestroy() {

		},
		destroyed() {},
		methods: {
			submitmessage() {
				if (this.usermessage) {
					this.$refs.mess.setAttribute("style", "display:none");
					axios({
						url: this.$api.commonUrl + "message/add",
						method: "POST",
						data: {
							kId: this.$route.query.id,
							messageContent: this.usermessage,
							messageUser: this.userid
						},
						headers: {
							Authorization: "Bearer " + this.token,
						},
					}).then((res) => {
						if (res.data.code == "200") {
							//提示
							this.$refs.popup.popupshow()
							this.getmessagelist()
							this.usermessage = null
						}
					}).catch((err) => {
						console.log(err);
					});
				} else {
					this.$refs.mess.setAttribute("style", "display:block");
				}
			},
			changetxt() {
				if (this.usermessage) {
					this.$refs.mess.setAttribute("style", "display:none");
				} else {
					this.$refs.mess.setAttribute("style", "display:block");
				}
			},
			getmessagelist() {
				new Promise((resolve, reject)=>{
					axios({
						url: this.$api.commonUrl + "message/id",
						method: "GET",
						params: {
							"id": this.$route.query.id,
							"pageNum": this.pageNum,
							"pageSize": this.pageSize,
							"status": '1'
						},
						headers: {
							Authorization: "Bearer " + this.token,
						},
					}).then((res) => {
						if (res.data.code == "200") {
							this.messagelist = res.data.data.pageList.list
							this.pages = res.data.data.pageList.pages
							if(parseInt(this.pages)>=5){
								for(let i = 1;i<=5;i++){
									if(this.pageNum>2){
										this.pageslist = [this.pageNum-2,this.pageNum-1,this.pageNum,this.pageNum+1,this.pageNum+2]
									}
									if(this.pageNum<=2){
										this.pageslist = [1,2,3,4,5]
									}
									if(this.pageNum>=this.pages-2){
										this.pageslist = [this.pages-4,this.pages-3,this.pages-2,this.pages-1,this.pages]
									}
								}
							}else if(parseInt(this.pages)<5){
								let newlist = []
								for(let i = 1;i<=parseInt(this.pages);i++){
									newlist.push(i)
								}
								this.pageslist = newlist
							}
							resolve()
						}
					}).catch((err) => {
						console.log(err);
					});
				}).then((res)=>{
					this.pushclass()
				})
			},
			pushclass(){
				let allpageelement = document.getElementsByClassName('pagenum')
				for(let i =0;i<allpageelement.length;i++){
					if(parseInt(allpageelement[i].getAttribute('data-id'))===this.pageNum){
						allpageelement[i].className = 'pagenum mr pageactive'
					}else{
						allpageelement[i].className = 'pagenum mr'
					}
				}
			},
			selectpage(i){
				this.pageNum = i
				this.getmessagelist()
			},
			sy(){
				if(this.pageNum!=1){
					this.pageNum = 1
					this.getmessagelist()
				}
			},
			syy(){
				if(this.pageNum>1){
					this.pageNum -= 1
					this.getmessagelist()
				}
			},
			xyy(){
				if(this.pageNum < this.pages){
					this.pageNum += 1
					this.getmessagelist()
				}
			},
			wy(){
				if(this.pageNum != this.pages){
					this.pageNum = this.pages
					this.getmessagelist()
				}
			},
			gettxt() {
				axios({
						url: this.$api.commonUrl + "knowledg/points/" + this.$route.query.id,
						method: "GET",
						headers: {
							Authorization: "Bearer " + this.token,
						},
					})
					.then((res) => {
						if (res.data.code == "200") {
							this.txtlist = res.data.data;
						}
					})
					.catch((err) => {
						console.log(err);
					});
			},
			gettime() {
				let yy = new Date().getFullYear();
				let mm = new Date().getMonth() + 1;
				let dd = new Date().getDate();
				let hh = new Date().getHours();
				let mf =
					new Date().getMinutes() < 10 ?
					"0" + new Date().getMinutes() :
					new Date().getMinutes();
				let ss =
					new Date().getSeconds() < 10 ?
					"0" + new Date().getSeconds() :
					new Date().getSeconds();
				return yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
			},
			setData(str) {
				let yy = new Date(str).getFullYear();
				let mm = new Date(str).getMonth() + 1;
				let dd = new Date(str).getDate();
				let hh = new Date(str).getHours();
				let mf =
					new Date().getMinutes() < 10 ?
					"0" + new Date().getMinutes() :
					new Date().getMinutes();
				let ss =
					new Date().getSeconds() < 10 ?
					"0" + new Date().getSeconds() :
					new Date().getSeconds();
				return yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
			},
		},
	};
</script>

<style scoped>
	.knowledgebasedetails {
		background: #f3ede3;
	}
	.knowledgebasedetails .pageactive span{
		background: #b7886c !important;
		color: #FFFFFF !important;;
	}
	.knowledgebasedetails .message {
		background: #ffffff;
	}

	.knowledgebasedetails .context {
		height: 3.5rem;
		background: url(../../assets/images/zsktopbag.png) no-repeat;
		background-size: 100% 100%;
		margin-top: 1rem;
		display: flex;
	}

	.knowledgebasedetails .bcc {
		position: absolute;
		left: 0px;
		right: 0px;
		top: 6rem;
		bottom: 0px;
		overflow-y: auto;
		background: #f3ede3 url(../../assets/images/zskbag.png) no-repeat;
		background-size: 100%;
		z-index: 2;
		width: 80rem;
		padding-left: calc((100% - 80rem) / 2);
		padding-right: calc((100% - 80rem) / 2);
	}

	.knowledgebasedetails .bcc::-webkit-scrollbar {
		width: 6px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}

	/*滚动条里面小方块*/
	.knowledgebasedetails .bcc::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #af805c;
	}

	/*滚动条里面轨道*/
	.knowledgebasedetails .bcc::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #ede3db;
	}

	.knowledgebasedetails .topbagdiv {
		background: url(../../assets/images/usertopbag.png);
		background-size: 100% auto;
		height: 6rem;
		display: flex;
		z-index: 2;
		box-shadow: 0px 0px 10px #efdcc9;
	}

	.knowledgebasedetails .logodiv,
	.knowledgebasedetails .backdiv {
		width: 25rem;
		height: 6rem;
	}

	.knowledgebasedetails .titlediv {
		width: calc(100% - 50rem);
		height: 6rem;
		position: relative;
	}

	.knowledgebasedetails .logodiv img {
		width: 16rem;
		height: 4.03rem;
		margin: calc(1.97rem / 2);
	}

	.knowledgebasedetails .titlediv {
		text-align: center;
		height: 6rem;
	}

	.knowledgebasedetails .usertitle {
		background: url(../../assets/images/usertitlebag.png) no-repeat;
		background-size: 100% 100%;
		width: 25rem;
		height: 4rem;
		line-height: 4.5rem;
		font-size: 2.571428rem;
		font-family: "STXingkai";
		color: #783d1a;
		position: absolute;
		margin: auto;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
	}

	.knowledgebasedetails .back .backimg {
		right: 1rem;
		top: 1rem;
	}

	.knowledgebasedetails .bcctitle {
		height: 4.5rem;
		    line-height: 5.5rem;
		font-size: 1.285714rem;
		display: flex;
		color: #5f3519;
	}

	.knowledgebasedetails .bcctitle-left,
	.knowledgebasedetails .bcctitle-right {
		flex: 1;
	}

	.knowledgebasedetails .bcctitle-left {
		font-weight: bold;
		padding-left: 1rem;
	}

	.knowledgebasedetails .bcctitle-right {
		text-align: right;
		padding-right: 1rem;
	}

	.knowledgebasedetails .bcctitle-right a {
		margin-left: 1rem;
		color: #5f3519;
		text-decoration: none;
	}

	.knowledgebasedetails .bcccontent {
		padding: 0.5rem;
	}

	.knowledgebasedetails .bcccontents {
		background: rgba(255, 255, 255, 1);
		padding: 0.5rem;
	}

	.knowledgebasedetails .ctt {
		background: #fff9ec;
		padding: 0.5rem;
		position: relative;
	}
	
	.knowledgebasedetails .ctt .ctttitle{
		position: absolute;
		top: -0.5rem;
		left: 1rem;
	}
	.knowledgebasedetails .ctt .ctttitle p{
		width: 3.214285rem;
		height: 6.428571rem;
		position: absolute;
		font-size: 1rem;
		color: #FFFFFF;
		writing-mode:horizontal-tb;
		writing-mode:vertical-rl; 
		line-height: 3.214285rem;
		text-align: center;
		top: -0.5rem;
	}
	.knowledgebasedetails .ctt .ctttitle img{
		width: 3.214285rem;
		height: 6.428571rem;
	}

	.knowledgebasedetails .cttitle {
		padding: 0.5rem;
		border: 2px solid #ffe8db;
	}

	.knowledgebasedetails .time {
		font-size: 0.9rem;
		color: #aca9a4;
		line-height: 1.2rem;
		text-align: right;
	}

	.knowledgebasedetails .cctitle {
		color: #5f3519;
		font-size: 2rem;
		font-weight: bold;
		line-height: 3rem;
		text-align: center;
		margin-top: 1rem;
		margin-bottom: 3rem;
		letter-spacing: 1rem;
	}

	.knowledgebasedetails .content {
		font-size: 1.142857rem;
		color: #87644d;
		line-height: 1.857142rem;
		padding-left: 1rem;
		padding-right: 1rem;
		padding-bottom: 4rem;
	}

	.knowledgebasedetails .footercontent {
		display: flex;
		height: 2rem;
		line-height: 2rem;
		padding-top: 3rem;
		border-bottom: 2px solid #ffe8db;
	}

	.knowledgebasedetails .footercontent div {
		flex: 1;
	}

	.knowledgebasedetails .footercontent .right {
		text-align: right;
	}

	.knowledgebasedetails .footercontent div a {
		color: #24211f;
		font-size: 0.9rem;
	}

	.knowledgebasedetails .mtitle {
		height: 2rem;
		line-height: 2rem;
		color: #5f3519;
		font-weight: bold;
		font-size: 1.142857rem;
		margin-top: 3rem;
	}

	.knowledgebasedetails .mtitle img {
		width: 1.3rem;
		height: 1.3rem;
		display: block;
		float: left;
		margin-top: 0.35rem;
		margin-right: 0.35rem;
	}

	.knowledgebasedetails .tttt {
		border: 1px solid #b7886c;
		width: calc(100% - 1rem - 4px);
		min-height: 10rem;
		resize: none;
		padding: 0.5rem;
		margin: 1px;
		font-size: 1.142857rem;
		color: #87644d;
		display: block;
	}

	.knowledgebasedetails .textareabox {
		border: 2px solid #b7886c;
	}

	.knowledgebasedetails .submitbtnbox {
		text-align: right;
		margin-top: 0.8rem;
	}

	.knowledgebasedetails .submitbtnbox a {
		    background: #a73a29;
		    color: #fffef4;
		    font-size: 1.071428rem;
		    text-decoration: none;
		    display: block;
		    width: 7rem;
		    height: 3rem;
		    float: right;
		    text-align: center;
		    line-height: calc(3rem - 6px);
				position: relative;
	}
	
	.aaaaaaaaaaaaaaaaaa{
		position: absolute;
		top: 2px;
		left: 2px;
		right: 2px;
		bottom: 2px;
		border: 1px solid #c27566;
	}

	.knowledgebasedetails .submitbtnbox span {
		font-size: 0.9rem;
		color: red;
		float: left;
		display: none;
	}

	.knowledgebasedetails .messageitembox {
		padding: 0.5rem;
	}

	.knowledgebasedetails .messageitembox .messageitem {
		border-bottom: 1px solid #ffe8db;
		padding-bottom: 2rem;
		padding-top: 1rem;
	}

	.knowledgebasedetails .messageitembox .messageitem:last-child {
		border: none;
	}

	.knowledgebasedetails .messageitembox .messageitem .top {
		display: flex;
		height: 2rem;
		line-height: 2rem;
	}

	.knowledgebasedetails .messageitembox .messageitem .top div {
		flex: 1;
	}

	.knowledgebasedetails .messageitembox .messageitem .top div:nth-child(1) {
		font-size: 1.2rem;
		color: #65615f;
		font-weight: bold;
	}

	.knowledgebasedetails .messageitembox .messageitem .top div:nth-child(2) {
		text-align: right;
		color: #aca9a4;
		font-size: 0.9rem;
	}

	.knowledgebasedetails .itemccc {
		text-indent: 2em;
		line-height: 1.8rem;
		font-size: 1.142857rem;
		color: #65615f;
		padding-top: 0.5rem;
	}

	.knowledgebasedetails .hfhf {
		border: 1px solid #b7886c;
		background: #fffcf7;
		padding: 1rem;
		margin-top: 2rem;
	}

	.knowledgebasedetails .pagediv {
		height: 3.5rem;
		line-height: 3.5rem;
		text-align: center;
	}

	.knowledgebasedetails .pagenum {
		width: 2rem;
	}

	.knowledgebasedetails .pagebtn {
		width: 4.5rem;
	}

	.knowledgebasedetails .pagebtn,
	.knowledgebasedetails .pagenum {
		background: #ffffff;
		color: #b7886c;
		font-size: 0.9rem;
		text-decoration: none;
		display: inline-block;
		height: 2rem;
		position: relative;
		margin-top: 0.75rem;
	}

	.knowledgebasedetails .pagebtn span,
	.knowledgebasedetails .pagenum span {
		border: 1px solid #b7886c;
		display: block;
		position: absolute;
		left: 2px;
		right: 2px;
		bottom: 2px;
		top: 2px;
		line-height: calc(2rem - 6px);
		text-align: center;
	}

	.knowledgebasedetails .pagediv_left {
		color: #5f3519;
		font-size: 1.1rem;
		font-weight: bold;
		float: left;
	}
	.aaaaaaa{
		background: rgba(255, 255, 255, 0.6);
	}
</style>
